import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { UiBreakpointsService } from '@ib-core/services/ui-breakpoints.service';
import { AuthFacadeService } from '@ib-core-services/auth-facade.service';
import { IB_ROUTES } from '@ib-enums/routes.enum';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { filter, takeUntil } from 'rxjs';

import { NavigationService } from '../../../core/services/navigation.service';

@Component({
  selector: 'ib-not-auth-header',
  templateUrl: './not-auth-header.component.html',
  styleUrls: ['./not-auth-header.component.scss'],
})
export class NotAuthHeaderComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy
{
  public LOGIN = NavigationService.getRouteUrl(IB_ROUTES.LOGIN);
  public SIGN_UP = NavigationService.getRouteUrl(IB_ROUTES.SIGN_UP);
  public FORGOT_PASSWORD = NavigationService.getRouteUrl(
    IB_ROUTES.FORGOT_PASSWORD,
  );
  public RESET_PASSWORD = NavigationService.getRouteUrl(
    IB_ROUTES.RESET_PASSWORD,
  );

  public currUrl: string;

  constructor(
    public router: Router,
    public actRoute: ActivatedRoute,
    public bpS: UiBreakpointsService,
    private authFacadeS: AuthFacadeService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.currUrl = this.router.url;
    console.log('this.currUrl: ', this.currUrl, typeof this.currUrl);
    this.router.events
      .pipe(
        filter(event => {
          // console.log('router event: ', event);
          return event instanceof NavigationEnd;
        }),
        takeUntil(this.destroy$),
      )
      .subscribe((e: NavigationEnd) => {
        this.currUrl = e.url;
      });
  }

  ngOnDestroy(): void {
    super.destroySubscriptions();
  }

  logout(): void {
    this.authFacadeS.logout();
  }
}
